import { imagesUrl } from './constants';

const getTenantEyepassImage = (image, tenantId) => {
  return `${imagesUrl}/eyepass/${tenantId}/${image}`;
};

export default getTenantEyepassImage;
